<template>
    <div class="container is-fluid">
		<div class="level mb-4">
			<div class="level-left">
				<h1 class="title">List Users and Governing Bodies</h1>
			</div>
			<div class="level-right">
				<div class="buttons">
				<a :href="'mailto:' + this.$auth.user.email + '?bcc=' + emailList" target="_blank" class="button is-link ">Compose Email To All</a>
				<router-link to="/users/add"><button class="button is-success "  >Create New User</button></router-link>
				</div>
			</div>
		</div>
		
			  <div class="box" v-if="users.length > 0">	

				  <table class="table is-fullwidth is-hoverable is-striped" id="usertable">
					  	<thead>
							  <tr>
								<th>Name</th>
								<th>Email</th>
								<th>Sports</th>
								
								<th></th>
								  </tr>
							  </thead>
							  <tbody>
								<tr valign="top"  v-for="row in users" v-cloak v-bind:key="row.id">
									<td ><router-link :to="{path: '/users/' + row.id}">{{row.forename}} {{row.surname}}</router-link></td>
									<td >{{row.email}}</td>
									<td >{{ row.sport_list }}</td>
									
									<td>
									<button class="button is-danger is-small"  @click="deleteUser($event, row.id)">Delete</button>
									</td>
								</tr>
								  </tbody>
					  </table>
			  </div>
				
			</div>

</template>

<script>
import XLSX from 'xlsx';
import UserService from '@/services/UserService.js';
import UtilityService from '@/services/UtilityService.js';

export default {
 name: 'ListUsers',
 props: [],
 methods: {
	 exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('usertable'), {sheet:"Users"});
		 XLSX.writeFile(wb, 'users.xlsx')

     },
     async getUsers() {
			
			UserService.getUsers(this.accessToken)
			.then(
				(users => {
				this.$set(this, "users", users);
				}).bind(this)
			);
		},
	   async deleteUser(event, userId)
      {
        event.target.disabled = 1;
        
        UtilityService.deleteSimpleApiData(this.accessToken, 'users/' + userId).then(
          () => this.getUsers()
        );

        
      }
 },

  data() {
    return {
      errors: [],
	users: [],
	accessToken:''
    
    }
  },
  created() {
    this.getAccessToken()
    .then(() => { 
		this.getUsers()
    });
  },
  computed: {
    emailList: function () {
      return this.users.map(item => item.email).join(';')
    }
  },
  
}
</script>